import { render, staticRenderFns } from "./ViewEditDialogButtons.vue?vue&type=template&id=61bc52bb"
import script from "./ViewEditDialogButtons.vue?vue&type=script&lang=js"
export * from "./ViewEditDialogButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports